import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { NotificationsBannerStore } from 'entities/Notifications/ui/NotificationsBanner/store/notificationsBannerStore'

export const NotificationsBanner = observer(() => {
  const entities = useEntitiesContext()
  const [store] = useState(() => new NotificationsBannerStore(entities))
  const { show, init, dispose, initBanner } = store

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  useEffect(() => {
    initBanner()
  }, [show])

  return null
})
